import { queryClient, useQuery, useMutation } from '../../../hooks';

import * as customersService from '../service';
import { CustomersCacheKeys } from '../consts';

export const useCustomerProfile = (customerId?: string) => {
  const getCustomerProfileDetails = useQuery({
    queryFn: customersService.getCustomerProfileDetails,
    queryKey: [CustomersCacheKeys.GetCustomerProfile],
    enabled: !customerId,
  });

  const getOtherCustomerProfile = useQuery({
    queryFn: async () =>
      customersService.getOtherCustomerProfile(customerId as string),
    queryKey: [CustomersCacheKeys.GetCustomerProfile, customerId],
    enabled: !!customerId,
  });

  const updateCustomerProfileDetails = useMutation({
    mutationFn: customersService.updateCustomerProfileDetails,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: customerId
          ? [CustomersCacheKeys.GetCustomerProfile, customerId]
          : [CustomersCacheKeys.GetCustomerProfile],
      });
    },
  });

  const customerProfileDetailsUpdated = useMutation({
    mutationFn: customersService.customerProfileDetailsUpdated,
  });

  const uploadAvatar = useMutation({
    mutationFn: customersService.uploadCustomerAvatar,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: customerId
          ? [CustomersCacheKeys.GetCustomerProfile, customerId]
          : [CustomersCacheKeys.GetCustomerProfile],
      });
    },
  });

  const deleteAvatar = useMutation({
    mutationFn: customersService.deleteCustomerAvatar,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: customerId
          ? [CustomersCacheKeys.GetCustomerProfile, customerId]
          : [CustomersCacheKeys.GetCustomerProfile],
      });
    },
  });

  return {
    getCustomerProfileDetails,
    getOtherCustomerProfile,
    updateCustomerProfileDetails,
    customerProfileDetailsUpdated,
    uploadAvatar,
    deleteAvatar,
  };
};
